// import Logo from "../assets/images/logo.png";
// import "../assets/css/navbar.css";
// import Download from "../assets/images/download.svg";
// import POLICY from "../files/KPMG Whistleblowing Policy.pdf";
// import FAQ from "../files/Frequently Asked Questions (FAQs) on Whistleblowing.pdf";
// export default function Navbar() {
//   return (
//     <div className="navbar pt-3 pb-5">
//       <div className="container-fluid px-5">
//         <div className="logo">
//           <a href="index.html" className="text-decoration-none">
//             <img src={Logo} alt="logo" className="logo" />
//           </a>
//         </div>
//         <div>
//           <ul className="d-flex">
//             {/* <li className="list-unstyled mx-4">
//               <a href="/" className="text-decoration-none  styler text-color">
//                 Home
//               </a>
//             </li> */}
//             <li className="list-unstyled mx-4">
//               <a
//                 href={POLICY}
//                 className="text-decoration-none text-dark styler wbp"
//                 download="KPMG Whistleblowing Policy.pdf"
//                 target="_blank"
//                 rel="noreferrer"
//               >
//                 WhistleBlowing policy{" "}
//                 <img src={Download} alt="download" className="download" />
//               </a>
//             </li>
//             <li className="list-unstyled mx-4">
//               <a
//                 href={FAQ}
//                 className="text-decoration-none text-dark styler wbp"
//                 download="Frequently Asked Questions (FAQs) on Whistleblowing.pdf"
//                 target="_blank"
//                 rel="noreferrer"
//               >
//                 FAQs
//                 <img src={Download} alt="download" className="download" />
//               </a>
//             </li>
//             {/* <li className="list-unstyled mx-4">
//               <a href="#" className="text-decoration-none text-dark">
//                 Hotmail
//               </a>
//             </li>{" "}
//             <li className="list-unstyled mx-4">
//               <a href="#" className="text-decoration-none text-dark">
//                 Hotline
//               </a>
//             </li> */}
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// }

import { useState } from "react";
import Logo from "../assets/images/logo.png";
import Download from "../assets/images/download.svg";
import POLICY from "../files/KPMG Whistleblowing Policy.pdf";
import FAQ from "../files/Frequently Asked Questions (FAQs) on Whistleblowing.pdf";
import "../assets/css/navbar.css";

export default function Navbar() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="navbar pt-3 pb-5">
      <div className="container-fluid  px-3 px-lg-5 ">
        <div className="logo">
          <a href="index.html" className="text-decoration-none">
            <img src={Logo} alt="logo" className="logo" />
          </a>
        </div>
        <button className="navbar-toggle" onClick={toggleSidebar}>
          <span className="hamburger"></span>
        </button>
        <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
          <ul className="sidebar-menu">
            <li className="list-unstyled mx-4">
              <a
                href={POLICY}
                className="text-decoration-none text-dark styler wbp"
                download="KPMG Whistleblowing Policy.pdf"
                target="_blank"
                rel="noreferrer"
              >
                WhistleBlowing policy{" "}
                <img src={Download} alt="download" className="download" />
              </a>
            </li>
            <li className="list-unstyled mx-4">
              <a
                href={FAQ}
                className="text-decoration-none text-dark styler wbp"
                download="Frequently Asked Questions (FAQs) on Whistleblowing.pdf"
                target="_blank"
                rel="noreferrer"
              >
                FAQs
                <img src={Download} alt="download" className="download" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
